import { bl_cpcommerce_website_form_field_set_link_RowClass } from '../../dbschema/bl_cpcommerce_website_form_field_set_link.model';
import { BaseContainerModel } from '../base-container.model';

export class CpCommerceWebsiteFormFieldSetLinkContainerModel extends BaseContainerModel {
  bl_cpcommerce_website_form_field_set_link: bl_cpcommerce_website_form_field_set_link_RowClass = new bl_cpcommerce_website_form_field_set_link_RowClass();
}
